module.exports = __webpack_public_path__ + "static/media/splash.d5a40a43.jpg";